(function () {
  'use strict';

  angular.module('wsLrs.services').factory('MeasureRegistry', ['$http', '$q', 'Api', 'Resource', '$rootScope', 'User', function ($http, $q, Api, Resource, $rootScope, User) {
    $rootScope.$on('organization-selected', function () {
      registry.measures = {};
      registry._measures_promise = null;
      registry._measures_resource = new Resource("/measures", false, true);
      registry.categories = {};
      registry._categories_promise = null;
      registry._noneCategory = {
        name: "None",
        id: null
      };
      registry._promise = null;
    });
    var registry = {
      measures: {},
      categories: {},
      _measures_promise: null,
      _categories_promise: null,
      _measures_resource: new Resource("/measures", false, true),
      _noneCategory: {
        name: "None",
        id: null
      },
      clear: function clear() {
        registry.measures = {};
        registry.categories = {};
      },
      addMeasure: function addMeasure(measure) {
        registry.measures[measure.id] = _.extend({
          id: measure.id
        }, measure);
      },
      addCategory: function addCategory(category) {
        registry.categories[category.id] = _.extend({
          id: category.id
        }, category);

        // attach categories to measures
        for (var m in this.measures) {
          if (this.measures[m].measureCategoryName) {
            this.measures[m].measureCategory = _.findWhere(this.categories, {
              name: this.measures[m].measureCategoryName
            });
          } else {
            this.measures[m].measureCategory = registry._noneCategory;
          }
        }
      },
      add: function add(item) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$_type = _ref._type,
          _type = _ref$_type === void 0 ? 'measure' : _ref$_type;
        if (_type === 'measure') {
          registry.addMeasure(item);
        }
        if (_type === 'category') {
          registry.addCategory(item);
        }
      },
      get: function get(id) {
        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$_type = _ref2._type,
          _type = _ref2$_type === void 0 ? 'measure' : _ref2$_type,
          _ref2$_full = _ref2._full,
          _full = _ref2$_full === void 0 ? false : _ref2$_full;
        if (_type === 'measure' && registry.has(id)) {
          return _full ? registry.measures[id] : Object.assign({}, registry.measures[id].config, {
            id: id
          });
        }
        if (_type === 'category' && registry.has(id, {
          _type: _type
        })) {
          return registry.categories[id];
        }
      },
      getAllMeasures: function getAllMeasures() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$_full = _ref3._full,
          _full = _ref3$_full === void 0 ? false : _ref3$_full;
        return Object.keys(registry.measures).map(function (key) {
          return registry.get(key, {
            _full: _full
          });
        });
      },
      getAllMeasureCategories: function getAllMeasureCategories() {
        var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$_includeNoneCat = _ref4._includeNoneCategory,
          _includeNoneCategory = _ref4$_includeNoneCat === void 0 ? false : _ref4$_includeNoneCat;
        return Object.keys(registry.categories).filter(function (key) {
          return _includeNoneCategory || key !== "null";
        }).map(function (key) {
          return registry.get(key, {
            _type: 'category'
          });
        });
      },
      getAll: function getAll() {
        var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref5$_type = _ref5._type,
          _type = _ref5$_type === void 0 ? 'measure' : _ref5$_type,
          _ref5$_full = _ref5._full,
          _full = _ref5$_full === void 0 ? false : _ref5$_full,
          _ref5$_includeCategor = _ref5._includeCategories,
          _includeCategories = _ref5$_includeCategor === void 0 ? false : _ref5$_includeCategor;
        if (_type === 'measure' && _includeCategories) {
          return {
            measures: registry.getAllMeasures({
              _full: _full
            }),
            categories: registry.getAllMeasureCategories()
          };
        }
        if (_type === 'measure') {
          return registry.getAllMeasures({
            _full: _full
          });
        }
        if (_type === 'category') {
          return registry.getAllMeasureCategories();
        }
      },
      has: function has(id) {
        var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref6$_type = _ref6._type,
          _type = _ref6$_type === void 0 ? 'measure' : _ref6$_type;
        return _type === 'measure' ? registry.measures.hasOwnProperty(id) : registry.categories.hasOwnProperty(id);
      },
      prepareMeasures: function prepareMeasures() {
        var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref7$_includeCategor = _ref7._includeCategories,
          _includeCategories = _ref7$_includeCategor === void 0 ? false : _ref7$_includeCategor;
        try {
          if (!registry._measures_promise) {
            registry._measures_promise = registry._measures_resource.getAll({
              showHidden: true,
              ignoreReadPermissions: true
            }).then(function (measures) {
              return angular.forEach(measures, registry.add);
            });
          }
          if (_includeCategories) {
            return $q.all([registry._measures_promise, registry.prepareMeasureCategories()]);
          }
          return registry._measures_promise;
        } catch (e) {
          return $q.reject(e);
        }
      },
      prepareMeasureCategories: function prepareMeasureCategories() {
        try {
          if (!registry._categories_promise) {
            registry._categories_promise = $http.get(Api.url('/measure-categories')).then(function (_ref8) {
              var categories = _ref8.data.results;
              return categories;
            }).then(function (categories) {
              categories.unshift(registry._noneCategory);
              angular.forEach(categories, function (category) {
                return registry.add(category, {
                  _type: 'category'
                });
              });
            });
          }
          return registry._categories_promise;
        } catch (e) {
          $q.reject(e);
        }
      },
      setMeasuresOnCard: function setMeasuresOnCard(card) {
        if (!card || !card.configuration || !card.configuration.measures) {
          return;
        }

        // TODO: better way to handle unauthenticated users? (ie. shares)
        var user = User.get();
        var authenticated = !user.unauthenticated;
        var cfg = card.configuration;
        cfg.measures = _.map(cfg.measures, function (m) {
          if (m && m.id) {
            m = registry.get(m.id) || m;
          }

          // Add the timezone to the valueProducer, so we can access this
          // value in aggregation-utils measure display code
          if (m && m.valueProducer) {
            if (card.configuration.timezone) {
              m.valueProducer.timeZone = cfg.timeZone;
            }
            if (authenticated) {
              var userTimezone = user.user.timezone;
              if (userTimezone) {
                m.valueProducer.timeZone = userTimezone;
              }
            }
          }
          return m;
        });
      }
    };
    return registry;
  }]).factory('Measures', ['$http', '$q', 'Api', 'Resource', '$rootScope', function ($http, $q, Api, Resource, $rootScope) {
    $rootScope.$on('organization-selected', function () {
      res.def = null;
      res.getInProgress = false;
      res._resource = new Resource("/measures", false, true);
    });
    var res = {
      def: null,
      getInProgress: false,
      _resource: new Resource("/measures", false, true),
      list: function list() {
        var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            countReports: false
          },
          _limit = _ref9._limit,
          _offset = _ref9._offset,
          countReports = _ref9.countReports,
          searchText = _ref9.searchText,
          order_by = _ref9.order_by;
        // Don't cache, but prevent simultaneous fetches
        if (this.getInProgress) {
          return this.def.promise;
        }
        this.def = $q.defer();
        this.getInProgress = true;
        res._resource.list({
          countReports: countReports,
          showHidden: true,
          searchText: searchText,
          order_by: order_by,
          _limit: _limit,
          _offset: _offset
        }).then(function (measures) {
          res.def.resolve(measures);
          res.getInProgress = false;
        }, function () {
          res.def.resolve([]);
          res.getInProgress = false;
        });
        return this.def.promise;
      },
      getAll: function getAll() {
        var _ref0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            countReports: false
          },
          countReports = _ref0.countReports;
        // Don't cache, but prevent simultaneous fetches
        if (this.getInProgress) {
          return this.def.promise;
        }
        this.def = $q.defer();
        this.getInProgress = true;
        res._resource.getAll({
          countReports: countReports,
          showHidden: true,
          "order_by": "name",
          _limit: 1000
        }).then(function (measures) {
          res.def.resolve(measures);
          res.getInProgress = false;
        }, function () {
          res.def.resolve([]);
          res.getInProgress = false;
        });
        return this.def.promise;
      },
      get: function get(measureId) {
        // Don't cache, but prevent simultaneous fetches
        if (this.getInProgress) {
          return this.def.promise;
        }
        this.def = $q.defer();
        this.getInProgress = true;
        res._resource.get(measureId, {
          params: {
            returnReports: true,
            showHidden: true,
            "order_by": "name",
            _limit: 1000
          }
        }).then(function (measures) {
          res.def.resolve(measures);
          res.getInProgress = false;
        }, function () {
          res.def.resolve([]);
          res.getInProgress = false;
        });
        return this.def.promise;
      },
      getCommonMeasures: function getCommonMeasures(removeTimeline) {
        var def = $q.defer();
        res.getAll().then(function (measures) {
          measures = _.map(measures, function (measure) {
            var m = angular.copy(measure.config);
            m.id = measure.id;
            m.name = measure.name;
            m.measureCategoryName = measure.measureCategoryName;
            m.menuPosition = measure.menuPosition;
            return m;
          });
          if (removeTimeline) {
            measures = _.filter(measures, function (m) {
              return m.name !== 'Timeline';
            });
          }
          def.resolve(measures);
        }, function () {
          def.resolve([]);
        });
        return def.promise;
      },
      getLeaderboardMeasures: function getLeaderboardMeasures() {
        return res.getCommonMeasures();
      },
      getCorrelationMeasures: function getCorrelationMeasures() {
        return res.getCommonMeasures(true);
      }
    };
    return res;
  }]);
})();
